(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!window.tapMomentVideoToggleReady) {
    window.tapMomentVideoToggleReady = true;

    const syncVideoToggle = (video) => {
      const player = video.closest('[data-click-video-player]');
      const button = player && player.querySelector('[data-video-toggle]');

      if (button) {
        button.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
      }
    };

    const createClickVideo = (player) => {
      const video = document.createElement('video');
      const source = document.createElement('source');
      const poster = player.querySelector('.click-video-player__poster');

      video.controls = false;
      video.loop = false;
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = false;
      video.preload = 'none';
      video.playsInline = true;
      video.poster = player.dataset.videoPoster || '';
      video.setAttribute('playsinline', '');

      source.src = player.dataset.videoSrc;
      source.type = player.dataset.videoType || 'video/mp4';
      video.appendChild(source);

      if (poster) {
        poster.replaceWith(video);
      } else {
        player.prepend(video);
      }

      return video;
    };

    document.addEventListener('click', (event) => {
      const button =
        event.target.closest &&
        event.target.closest('[data-video-toggle]');

      if (!button) return;

      const player = button.closest('[data-click-video-player]');
      let video = player.querySelector('video');

      if (!video) {
        if (!player.dataset.videoSrc) return;
        video = createClickVideo(player);
      }

      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    ['play', 'pause', 'ended'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        (event) => {
          if (event.target.matches('[data-click-video-player] video')) {
            syncVideoToggle(event.target);
          }
        },
        true
      );
    });
  }

  } catch(e) { console.error(e); }
})();
})();
